export default __webpack_public_path__ + "static/stanleyknife-17490968c30e0daa7d972a22e5d25286.png";